import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const AREAS = [
  "Williams", "Bedford", "Mitchell", "Oolitic", "Springville",
  "Orleans", "Paoli", "Bloomington", "French Lick",
];

export const ServiceArea = () => (
  <section id="areas" data-testid="areas" className="relative overflow-hidden border-t border-white/10 bg-background px-6 py-24 md:px-12 md:py-32">
    <div className="glow-teal left-1/4 top-1/4 h-[360px] w-[360px] bg-teal-500/12" />
    <div className="relative mx-auto grid max-w-[1500px] grid-cols-1 gap-12 md:grid-cols-12 md:items-center">
      <div className="md:col-span-5">
        <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-primary">/ Where We Go</span>
        <h2 className="mt-6 font-cabinet text-4xl font-black uppercase leading-none tracking-tighter md:text-6xl">
          <span className="gradient-text">Service<br />Area</span>
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
          Fully mobile across Lawrence, Orange & Monroe counties. We come to you — home or work. Outside these towns? Give us a call and we'll try to make it work.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          {AREAS.map((a) => (
            <span key={a} data-testid={`area-${a.toLowerCase().replace(/ /g, '-')}`} className="flex items-center gap-2 border border-white/15 bg-card px-4 py-2 font-mono-x text-xs uppercase tracking-widest text-zinc-300">
              <MapPin size={12} className="text-primary" /> {a}
            </span>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="gradient-fill p-[2px] md:col-span-7"
      >
        <div className="bg-black">
          <iframe
            title="Velocity Detailing service area map"
            data-testid="area-map"
            src="https://www.google.com/maps?q=Orleans,+Indiana&z=9&output=embed"
            className="h-[360px] w-full grayscale-[0.3] md:h-[440px]"
            style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </motion.div>
    </div>
  </section>
);
